export const DADOS_CHAMADA = 'call-was-connected';
export const END_CALL = 'call-was-ended';
export const FINISHED_CALL = 'call-was-finished';
export const CALL_ANSWERED = 'call-was-answered';
export const CALL_FAILED = 'call-was-failed';
export const MANUAL_CALL_ANSWERED = 'manual-call-was-answered';
export const LOGGED_OUT = 'agent-was-logged-out';
export const AGENT_ENTERED_BREAK = 'agent-entered-work-break';
export const AGENT_LEFT_BREAK = 'agent-left-work-break';
export const AGENT_IDLE = 'agent-is-idle';
export const AGENT_IN_ACW = 'agent-in-acw';
export const AGENT_LOGIN_FAILED = 'agent-login-failed';
export const AGENT_IN_ACW_MANUAL = 'agent-entered-manual-acw';
export const AGENT_ENTERED_MANUAL = 'agent-entered-manual';
export const AGENT_LEFT_MANUAL = 'agent-left-manual';
export const LOGIN_FAILED = 'agent-left-manual';
export const ERROR = 'error';
export const MANUAL_CALL_QUALIFIED = 'manual-call-was-qualified';
export const CALL_WAS_ABANDONED = 'call-was-abandoned';
export const CALL_WAS_ABANDONED_DUE_AMD = 'call-was-abandoned-due-amd';
export const CALL_WAS_NOT_ANSWERED = 'call-was-not-answered';

export const DESTINO_RINGANDO = 'destinoringando';
export const FIM_CHAMADA = 'fimchamada';
export const RESPOSTA_FAZER_CHAMADA = 'respfazerchamada';
export const RESULT_DESLOGAR = 'resultdeslogar';
export const RESULT_DESPAUSAR = 'resultdespausar';
export const RESULT_LOGAR = 'resultlogar';
export const RESULT_PAUSAR = 'resultpausar';
